module.exports = __webpack_public_path__ + "static/media/values-bg.0d2fa446.png";